/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Forced_Update_MessageInputs */

const en_mobile_forced_update_message = /** @type {(inputs: Mobile_Forced_Update_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This version of Listening is no longer supported. Update the app to keep listening.`)
};

const es_mobile_forced_update_message = /** @type {(inputs: Mobile_Forced_Update_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta versión de Listening ya no es compatible. Actualiza la app para seguir escuchando.`)
};

/**
* | output |
* | --- |
* | "This version of Listening is no longer supported. Update the app to keep listening." |
*
* @param {Mobile_Forced_Update_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_forced_update_message = /** @type {((inputs?: Mobile_Forced_Update_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Forced_Update_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_forced_update_message(inputs)
	return en_mobile_forced_update_message(inputs)
});